// extracted by mini-css-extract-plugin
module.exports = {"exchangeAbout":"q3glXD","aboutHeader":"_0Gy1Gl","aboutText":"Axt5gM","aboutWhite":"gMUKKH","exchangeAboutLink":"__qj0J","extraAboutText":"t5QUi5"};